import React from 'react';

import logoUrl from 'shared/images/placer-logo-ai.svg';
import { UserSection } from './user-section/user-section';
import { SearchSection } from 'features/header/header-top-panel/search-section/search-section';
import { HeaderButtonGroupComponent } from './header-button-group/header-button-group';
import { NotificationsButton } from 'features/header/header-top-panel/notifications-button/notifications-button';
import { StarredReportsButton } from 'features/header/header-top-panel/starred-reports-button/starred-reports-button';
import { printModeSignal } from 'features/insights/components/legacy-print/utils';
import { PiButton } from 'features/header/header-top-panel/pi-button/pi-button';
import { getFeatureFlags } from 'core/flow-control';
import { useDrawerController } from 'features/pi/view/hooks/useDrawerController';

import styles from './header-top-panel.module.scss';

export const HeaderTopPanel = () => {
    const { accessibility_property_print_preview_ff, enable_pi_in_the_platform } = getFeatureFlags();
    const drawerController = useDrawerController();

    if (accessibility_property_print_preview_ff && printModeSignal.value) {
        return null;
    }

    return (
        <div className={styles.headerTopPanelWrapper}>
            <div className={styles.panelLeftSection}>
                <img className={styles.logo} src={logoUrl} alt="placer ai logo" />
                <SearchSection />
            </div>
            <HeaderButtonGroupComponent />
            <StarredReportsButton />
            <NotificationsButton />
            <UserSection />
            {/* This validation is due to a potential race condition with the user info initialization */}
            {enable_pi_in_the_platform && drawerController && (
                <PiButton drawerController={drawerController} />
            )}
        </div>
    );
};
